import React, { useState , useEffect} from "react";
import {
  Navbar,
  NavItem,
  NavbarToggler,
  Collapse,
  Nav,
  NavbarBrand,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
} from "reactstrap";

import logoHome from "assets/images/logoHome.svg";
import logo from "assets/images/logo.svg";
import "./style.scss";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import userImage from "assets/images/user.png";
import userImageLight from "assets/images/user.svg";
import languageImage from "assets/images/wide.svg";
import languageImageGray from "assets/images/wideGray.svg";
import menuHeader from "assets/images/menu.png";
// import ProfileService from "services/Client/ProfileService";

const languages = [
  { name: "English", code: "en" },
  { name: "العربية", code: "ar", dir: "rtl" },
];
const HeaderHome = () => {
  const [show, setIsShow] = useState(false);
  const toggle = () => setIsShow((prevState) => !prevState);
  const { t, i18n } = useTranslation();
  const authData = useSelector((state) => state.Auth);
  const [shadow,setShadow] = useState({className:'noShadow'})
  const handleScroll = () => { 
    if (document.documentElement.scrollTop > 20) {
      setShadow({
         className: 'headerShadow'
       });
      }
      else{
        setShadow({
          className: 'noShadow'
        });
     } 
   };
   useEffect(() => {
      window.onscroll = () => handleScroll()
    }, []);
  // const profileService = new ProfileService();
  // const [profileData, setProfileData] = useState({});
  // const getProfileDetails = async () => {
  //   const res = await profileService.getProfileData();
  //   setProfileData(res.data);
  //   getProfileDetails();
  // };
  // useEffect(() => {
  //   getProfileDetails();
  // }, []);
  // console.log(profileData);
  return (
    <div>
      <Navbar light fixed="top" className={`headerHome py-3 ${shadow.className}`} expand="lg">
        <div className="container-fluid d-flex align-items-center justify-content-between px-lg-3 px-0">
          <NavbarBrand href="/home">
            <img src={logoHome} alt="" className="imgLogoHome" />
            <img src={logo} alt="" className="imgLogo" />
          </NavbarBrand>
          <NavbarToggler
            onClick={() => {
              setIsShow(!show);
            }}
          >
            <i className="fa fa-bars fa-lg iconMenu"></i>
            <img src={menuHeader} className="img-fluid iconMenuWhite"/>
          </NavbarToggler>
          <Collapse className="ps-3" navbar>
            <Nav className="me-auto d-flex" navbar>
              <NavItem>
                <NavLink to={`/home`} className="nav-link active">
                  {t("Home")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to={`/templates`} className="nav-link">
                  {t("Templates")}
                </NavLink>
              </NavItem> 
              <NavItem>
                <NavLink to={`/subscriptions`} className="nav-link">
                  {t("Subscriptions & Plans")}
                </NavLink>
              </NavItem>
              {authData.userType === "user" && authData.token?.length > 0 ?
              <NavItem>
                <NavLink to={`/client/projects`} className="nav-link">
                  {t("Projects")}
                </NavLink>
              </NavItem> : ""}
              <NavItem>
                <NavLink to={`/contact-us`} className="nav-link">
                  {t("Contact us")}
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink to={`/blog`} className="nav-link">
                  {t("Blog")}
                </NavLink>
              </NavItem> */}
              
            </Nav>
            {authData.userType === "user" && authData.token.length > 0 ? (
              <Nav className="align-items-center">
              <UncontrolledDropdown inNavbar nav>
              <DropdownToggle disabled nav>
                <span className="font-size-14 d-flex">
                  <span>EN</span>
                  <img src={languageImage} className="imgLanguage img-fluid mx-2"/>
                  <img src={languageImageGray} className="imgLanguageGray img-fluid mx-2"/>
                </span>
              </DropdownToggle>
              <DropdownMenu right>
                {languages.map((lang, index) => {
                  return (
                    <DropdownItem
                      key={index}
                      onClick={() => {
                        i18n.changeLanguage(lang.code);
                      }}
                    >
                      {lang.name}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
              <UncontrolledDropdown className="userDropdown" navbar>
                <DropdownToggle className="ps-0 d-flex align-items-center" nav caret>
                  <img src={userImage} alt="" className="pe-2 imgUser" />{" "}
                  <img src={userImageLight} alt="" className="pe-2 imgUserLight" />{" "}
                  {/* <i className="fa fa-user-circle fa-lg mx-2 text-white"></i> */}
                  {authData.user_name}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <NavLink
                      className="text-decoration-none d-block py-0 text-dark"
                      to="/profile"
                    >
                      Profile
                    </NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink
                      className="text-decoration-none d-block py-0 text-dark"
                      to="/logout"
                    >
                      Logout
                    </NavLink>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              </Nav>
            ) : (
              <Nav className="ms-auto dropHome gap-3 gap-lg-0 d-lg-flex align-items-lg-center" navbar>
                <NavItem className="p-0">
                  <UncontrolledDropdown disabled inNavbar nav>
                    <DropdownToggle nav>
                      <span className="font-size-14 d-flex">
                        <span>EN</span>
                        <img src={languageImage} className="imgLanguage img-fluid mx-2"/>
                        <img src={languageImageGray} className="imgLanguageGray img-fluid mx-2"/>
                      </span>
                    </DropdownToggle>
                    <DropdownMenu right>
                      {languages.map((lang, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => {
                              i18n.changeLanguage(lang.code);
                            }}
                          >
                            {lang.name}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </NavItem>
                <Link to="/login">
                  <button className="btn btnLogin btnHeightLg fw-bold px-4 shadow-none">
                    {t("Log In ")}
                  </button>
                </Link>
                <Link to="/register">
                  <button className="btn btn-primary btnHeightLg fw-bold px-4">
                    {t("Create Account")}
                  </button>
                </Link>
              </Nav>
            )}
          </Collapse>
        </div>
      </Navbar>
      <Offcanvas isOpen={show}>
        <OffcanvasHeader toggle={toggle}>
          <img src={logo} alt="" className="imgLogo" />
        </OffcanvasHeader>
        <OffcanvasBody className="navbarDashboard">
          <Nav className="me-auto" navbar>
            <NavItem>
              <NavLink to={`/home`} className="nav-link">
                {t("Home")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to={`/templates`} className="nav-link">
                {t("Templates")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to={`/subscriptions`} className="nav-link">
                {t("Subscriptions & Plans")}
              </NavLink>
            </NavItem>
            {authData.userType === "user" && authData.token.length > 0 ?
            <NavItem>
              <NavLink to={`/client/projects`} className="nav-link">
                {t("Projects")}
              </NavLink>
            </NavItem>: ""}
            <NavItem>
              <NavLink to={`/contact-us`} className="nav-link">
                {t("Contact us")}
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink to={`/blog`} className="nav-link">
                {t("Blog")}
              </NavLink>
            </NavItem> */}
            {/* <NavItem>
              <UncontrolledDropdown inNavbar nav>
                <DropdownToggle caret nav>
                  <span className="font-size-14"> {t("lang")} </span>
                </DropdownToggle>
                <DropdownMenu right>
                  {languages.map((lang, index) => {
                    return (
                      <DropdownItem
                        key={index}
                        onClick={() => {
                          i18n.changeLanguage(lang.code);
                        }}
                      >
                        {lang.name}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </NavItem> */}
          </Nav>
          {authData.userType === "user" && authData.token.length > 0 ? (
            <UncontrolledDropdown navbar>
              <DropdownToggle className="text-dark ps-0" nav caret>
                <img src={userImage} alt="" className="pe-2 imgUser" />{" "}
                {/* <img src={userImageLight} alt="" className="pe-2 imgUserLight" />{" "} */}
                {authData.user_name}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <NavLink
                    className="text-dark text-decoration-none d-block py-0"
                    to="/profile"
                  >
                    Profile
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink
                    className="text-dark text-decoration-none d-block py-0"
                    to="/logout"
                  >
                    Logout
                  </NavLink>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          ) : (
            <Nav className="mx-auto" navbar>
              <Link to="/login">
                <button className="btn btn-outline-primary btnHeightLg fw-bold px-4 mt-3 w-100">
                  {t("Login to your account")}
                </button>
              </Link>
              <Link to="/register">
                <button className="btn btn-primary btnHeightLg fw-bold px-4 mt-3 w-100">
                  {t("Create new account")}
                </button>
              </Link>
            </Nav>
          )}
        </OffcanvasBody>
      </Offcanvas>
    </div>
  );
};
export default HeaderHome;
